var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paginate',{staticClass:"pagination",attrs:{"page-count":_vm.pageCount,"click-handler":_vm.clickHandler,"prev-text":_vm.prevText,"next-text":_vm.nextText}})}
var staticRenderFns = []

export { render, staticRenderFns }